export const environment = {
  production: true,
  websiteName: "bern",
  cookie: "A81915A6B20D65DA0CC786C5094FB45F",
  widgetUid: "93ffd436-4bd6-49e7-99cc-818fdc579b7a",
  color2: "#ed6841",
  color2_80: "#009c7780",
  color4: "#009c77",
  color7: "#ed6841",
  email: "info@youseebaern.ch",
  telephone: "+41 (0) 31 331 84 84",
  translationsPath: "widget",
  shouldShowResources: false,
  font: {
    name: "Avenir",
    url: "assets/fonts/avenir/avenir-roman.woff2",
    format: "woff2",
  },
  apiPath: "https://stage.realm.doc-booker.com/ab-new-mt",
  websiteRecaptchaKey: "",
};



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/environments/environment.ts